import { Scenario } from "@opstel/query/api/scenario";
import { useEffect, useState } from "react";
import { useLocalStorageManager } from "./useLocalStorageManager";

interface QueryStatus {
  readonly isFetching: boolean;
  readonly isError?: boolean;
}

export interface PrepareStoreResult {
  readonly isStoreLoading: boolean;
}

type LoadingState = "Unloaded" | "Loading" | "Loaded";

export function usePrepareStore(
  scenario: Scenario | null | undefined,
  queries: readonly QueryStatus[],
): PrepareStoreResult {
  const { prepareStore } = useLocalStorageManager();
  const [loadingState, setLoadingState] = useState<LoadingState>("Unloaded");

  const isFetching = queries.some((query) => query.isFetching);
  const isError = queries.some((query) => query.isError);

  useEffect(() => {
    if (isFetching) {
      setLoadingState("Loading");
    } else if (scenario && !isFetching && !isError) {
      prepareStore(scenario);
      setLoadingState("Loaded");
    } else {
      setLoadingState("Unloaded");
    }
  }, [scenario, isFetching, isError, prepareStore]);

  const isStoreLoading = loadingState === "Loading";

  return { isStoreLoading };
}
